<template>
  <ImportByFile 
    :title="$t('menu.import_orders')"
    :resource="$t('menu.lists')"
    import_endpoint="orders/import" 
    :csv_xlsx="true"
    csv_model="modelo_import_linha_de_montagem.csv" 
    xlsx_model="modelo_import_linha_de_montagem.xlsx"
  />
</template>

<script>
import ImportByFile from '../shared/ImportByFile.vue'
export default {
  components: { ImportByFile },
}
</script>